// firebase.js
import { initializeApp } from "firebase/app";
import { getAuth, signInWithPhoneNumber } from "firebase/auth";
import { RecaptchaVerifier } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyDw7mK_fewrv0F_hIX1yXOShqRhLKJEjww",
  authDomain: "gdc-lalitpur.firebaseapp.com",
  projectId: "gdc-lalitpur",
  storageBucket: "gdc-lalitpur.firebasestorage.app",
  messagingSenderId: "128904210449",
  appId: "1:128904210449:web:94f1d0392b9d25f5b4a9b0",
  measurementId: "G-E8JMTTB4ZB"
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);

export { auth, RecaptchaVerifier, signInWithPhoneNumber };
